export default{
    lang:"es",
    fontFamily:"en-font-family",
    fontFamilyTitle:"en-font-family-title",
    requestLang:"en_US",
    type: "en",
}